import { defineNuxtPlugin, storeToRefs } from '#imports';
import { usePanelActionStore } from '@/widgets/panel-action/store';
import { useFeedbackStore } from '@/widgets/dialog-action-feedback/store';

export default defineNuxtPlugin({
	hooks: {
		'app:created': () => {
			document?.addEventListener('keydown', (e) => {
				const content = document.getSelection()?.toString() ?? '';

				if ((e.ctrlKey && e.keyCode === 13) && content?.length > 0) {
					const { showSpecialDialog } = usePanelActionStore();
					const feedbackStore = useFeedbackStore();
					const { selection } = storeToRefs(feedbackStore);

					selection.value = content;
					showSpecialDialog('feedback');
				}
			});
		},
	},
});
